// @flow

import baseSchema, {
  findDependentAlertTypeSchema,
  findSchemaPropertyByName,
  findSchemaRequired,
  baseUiSchema,
} from "./base-schema";
import type { Schemas } from "./types";

export const schema = (schema: ?Object) => {
  const typeSchema = findDependentAlertTypeSchema(schema, "X_DAY_TYPE_IN_Y_PERIOD_TYPE");

  return {
    ...baseSchema,
    properties: {
      ...baseSchema.properties,
      xDayTypeInYPeriodType: {
        required: findSchemaRequired(typeSchema, "xDayTypeInYPeriodType"),
        title: "X Day Type In Y Period Type",
        properties: {
          days: {
            type: "integer",
            title: "Days",
          },
          dayType: findSchemaPropertyByName(typeSchema, "xDayTypeInYPeriodType", "dayType"),
          period: {
            type: "integer",
            title: "Period",
          },
          periodType: {
            title: "Period Type",
            type: "string",
            oneOf: [
              { title: "Days", const: "D" },
              { title: "Months", const: "M" },
              { title: "Weeks", const: "W" },
            ],
          },
          fteProRata: findSchemaPropertyByName(typeSchema, "xDayTypeInYPeriodType", "fteProRata"),
        },
        type: "object",
      },
    },
    required: [...baseSchema.required, "xDayTypeInYPeriodType"],
  };
};

export const uiSchema = (t: (s: string) => string) => ({
  ...baseUiSchema(t),
  xDayTypeInYPeriodType: {
    fteProRata: {
      "ui:title": t("ALERTS_ALERT_FTE_PRO_RATA_ADJUSTMENT"),
      "ui:widget": "toggle",
    },
  },
});

const schemas: Schemas = {
  schema,
  uiSchema,
};

export default schemas;
